import * as React from 'react';

import styles from './Subheader.module.scss';
import SubheaderSlot from './SubheaderSlot';
import { SubheaderProps } from './types';
import { useWindowSize } from '../../hooks/useWindowSize';
import { LARGE_BREAKPOINT } from '../modular-grid/constants';
import { CarouselSlider } from '../Carousel';

const Subheader: React.FC<SubheaderProps> = ({
  items,
  onClick,
  navHorizontalPadding = 0,
  background = 'white',
  initialScroll,
  isSubNavigation,
}) => {
  const handleItemClick = (
    e: React.MouseEvent<{}>,
    index: number,
    type: string,
    title: string
  ) => {
    e.preventDefault();
    onClick({ index, type, title });
  };

  const shouldBeArrowSlider =
    useWindowSize().width >= LARGE_BREAKPOINT.min && !isSubNavigation
      ? true
      : false;

  return (
    <div
      className={`${styles[`wrapper__${navHorizontalPadding}`]}`}
      style={{ backgroundColor: background }}
      data-testid="subheader-wrapper"
    >
      <CarouselSlider
        style={shouldBeArrowSlider ? 'arrowSlider' : 'slider'}
        edgeSlidesPadding={navHorizontalPadding}
        initialScroll={initialScroll}
      >
        {items.map((item, index) => (
          <div
            className={styles.slot}
            key={index}
            data-testid={`${index}-slot`}
          >
            <SubheaderSlot
              data-testid={'subheader-slot'}
              item={item}
              onClick={e => handleItemClick(e, index, item.type, item.title)}
            />
          </div>
        ))}
      </CarouselSlider>
    </div>
  );
};

export default Subheader;
